import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appHeroIcon]'
})
export class HeroIconDirective implements OnInit {
    @Input() iconName: string;
    @Input() iconSrc: string = './assets/icons/heroicons-solid.svg';
    @Input() iconColor: string;


    constructor(private el: ElementRef) { }

    ngOnInit(): void {
        this.setIcon();
    }

    private setIcon(): void {
        const svgNamespace = 'http://www.w3.org/2000/svg';


        fetch(this.iconSrc)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error('Network response was not ok.');
            })
            .then(svgText => {
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');

                // Log per verificare se il documento SVG è stato parsato correttamente

                const svgElement = svgDoc.getElementById(this.iconName);

                if (svgElement) {

                    this.el.nativeElement.innerHTML = '';

                    const importedSvg = document.importNode(svgElement, true);

                    if (this.iconColor) {
                        importedSvg.setAttribute('fill', this.iconColor);
                    }

                    this.el.nativeElement.appendChild(importedSvg);
                } else {
                    console.error(`Icon ${this.iconName} not found in ${this.iconSrc}`);
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }
}
